import script from "./StatisticsList.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsList.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsList.vue?vue&type=style&index=0&id=125d28da&lang=scss"

const __exports__ = script;

export default __exports__